import { z } from 'zod';

export const loginSchema = z.object({
  loginId: z
    .string()
    .trim()
    .min(4, 'auth.errors.loginIdMin')
    .max(32, 'auth.errors.loginIdMax'),
  password: z
    .string()
    .min(1, 'auth.errors.passwordRequired')
    .max(128, 'auth.errors.passwordMax'),
  rememberMe: z.boolean().optional(),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
